export const environment = {
    appVersion: require('../../package.json').version + '-dev',
    production: true,
    domain: 'dev.noteradar.at',
    feedbackUrl: 'https://dev.noteradar.at/api/feedback.php',
    matomoTrackerUrl: 'https://devmatomo.noteradar.at/',
    matomoSiteId: '1',
};
